export default {
  site: 'cyan',
  project: 'deep-orange',
  extension: 'orange',
  user: 'purple',
};
